// Libraries
import React, { useContext } from 'react';

// Services and Contexts
import LanguageContext from '../../../contexts/LanguageContext';
import RatingsContext from '../../../contexts/RatingsContext';

// Components
import CategoryRatingDiagram from './CategoryRatingDiagram';

// Material-UI
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export default function CategoryRating({ userRatings }) {
  const { translate, language } = useContext(LanguageContext);
  const { ratings } = useContext(RatingsContext);
  const theme = useTheme();
  const breakPoint = useMediaQuery(theme.breakpoints.up('sm'));

  const columnTitles = ratings.byCategory.diagram.colLabels.map((title) => title[language]);
  const rowTitles = ratings.byCategory.diagram.rowLabels.map((title) => title[language]);

  const generateCellValues = (label, ratings) => {
    return new Array(5).fill('').map((row, rowIndex) => {
      return new Array(5).fill('').map((column, columnIndex) => {
        return {
          label,
          value: ratings[columnIndex] > rowIndex ? 20 + rowIndex * 20 : 0
        };
      });
    });
  };

  const renderInformation = () => {
    return (
      <Box>
        <Typography variant="h6" paragraph>
          <strong>{translate('SCREEN_RESULTS_RATING_BY_CATEGORY_TITLE')}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          {translate('SCREEN_RESULTS_RATING_BY_CATEGORY_DESCRIPTION')}
        </Typography>
      </Box>
    );
  };

  return (
    <Box textAlign="left" px={4}>
      {renderInformation()}
      <Box mt={0} mb={6}>
        <CategoryRatingDiagram
          tableStrokeWidth={breakPoint ? 10 : 4}
          columnTitles={columnTitles}
          rowTitles={rowTitles}
          cellData={generateCellValues('✓', userRatings)}
        />
      </Box>
    </Box>
  );
}
